import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { CircuitCreated, createCircuit } from '~/generated';
import { extractData } from '~/utils/query-utils';

type CreateCircuitInput = {
  name: string;
  language: string;
  circuitOverseerName?: string;
  circuitOverseerEmail?: string;
};

export const useCreateCircuit = (
  options: UseMutationOptions<
    CircuitCreated,
    unknown,
    CreateCircuitInput,
    unknown
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (circuit) =>
      extractData(
        createCircuit({
          body: {
            name: circuit.name,
            language: circuit.language,
            circuitOverseer:
              circuit.circuitOverseerName == null
                ? null
                : {
                    name: circuit.circuitOverseerName,
                    email: circuit.circuitOverseerEmail || null,
                  },
          },
        })
      ),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['circuits'],
      });
      options.onSuccess?.(...args);
    },
  });
};
